var map = {
	"./en.json": "e312",
	"./en/Ecopledge.json": "c4a3",
	"./en/Home.json": "5cc6",
	"./en/Myecopledge.json": "e56d",
	"./en/about_old.json": "1ac6",
	"./en/old_myMe.json": "cc1e",
	"./en/ourDashboard.json": "4de4",
	"./en/whatwedo.json": "8782"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4999";